/**
 * Add `parcelPurchasePriceArea` to the development object.
 */
const addPurchasePriceArea = (development) => {
  development.values.parcelPurchasePriceArea = development.values.existingStructureArea || development.values.parcelArea;
}

export default addPurchasePriceArea;
